/**
 * Diskriminanten für Fehler des Pinning-Gates.
 *
 * Alle Werte führen UI-seitig auf denselben Technical-Error-Screen mit der
 * Pinning-Variante. Sie werden getrennt gehalten, weil Telemetrie pro Sub-
 * Code zählt und die Pilot-Debugbarkeit eine genaue Ursache braucht.
 *
 * - `FingerprintMismatch`: keiner der Tenant-Keys matcht den Pin-Fingerprint
 *   aus dem Token — manipulierte Tenant-Config oder falscher Tenant-Host.
 * - `KeyImportFailed`: alle Schlüssel im Pool konnten nicht importiert werden
 *   (z. B. fehlerhaftes Base64 / kein RSA-OAEP-SPKI).
 * - `KeyTooWeak`: ein Schlüssel ließ sich importieren, lag aber unter
 *   `MIN_TENANT_KEY_MODULUS_BITS` — Tenant-Setup-Bug.
 * - `NoKeysConfigured`: `tenantPublicKeys` ist leer (Konfigurations-Bug).
 */
export const PinningError = {
  FingerprintMismatch: 'FINGERPRINT_MISMATCH',
  KeyImportFailed: 'KEY_IMPORT_FAILED',
  KeyTooWeak: 'KEY_TOO_WEAK',
  NoKeysConfigured: 'NO_KEYS_CONFIGURED',
} as const;

export type PinningError = (typeof PinningError)[keyof typeof PinningError];
